export default [
  {
    path: 'home',
    name: 'home',
    component: () => import('./HomePage.vue')
  }
]
